// extracted by mini-css-extract-plugin
export var bgImage = "pageHeaderWaveBackground-module--bgImage--0be44";
export var leftPath = "pageHeaderWaveBackground-module--leftPath--06bad";
export var rightPath = "pageHeaderWaveBackground-module--rightPath--dc363";
export var svgWrap = "pageHeaderWaveBackground-module--svgWrap--16d65";
export var waveBg = "pageHeaderWaveBackground-module--waveBg--2401d";
export var waveInner = "pageHeaderWaveBackground-module--waveInner--8aa8b";